import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { I18nModule } from '@app/i18n';
import { MaterialModule } from '@app/material.module';
import { ShellComponent } from './shell.component';
import { HeaderModule } from './header/header.module';
import { FooterModule } from '@app/shell/footer/footer.module';
import { SharedModule } from '@shared';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    MaterialModule,
    I18nModule,
    RouterModule,
    HeaderModule,
    FooterModule,
    SharedModule,
  ],
  declarations: [ShellComponent],
})
export class ShellModule {}
